define([
	"dojo/_base/declare",
	"underscore",
	"csi/table/matrix/Path",
	"csi/xml",
	"SpecificationDataSheet/_SharedSectionMatrixMixin",
	"src/SpecificationDataSheet/sharedSectionMatrixService",
], function(
	declare,
	_,
	Path,
	xml,
	_SharedSectionMatrixMixin,
	{specValueIdMap}
) {

	return declare([Path, _SharedSectionMatrixMixin], {
		columnPath: "Child:SharedSpecSections",
		columnSortAttr: xml.ATTR_NAME,
		restrictQuery: true,
		selectedColumnValueProperty: "selectedSharedSpecSections",
		selectedColumnValueDefaultsToAll: false,

		/**
		 * @override
		 * Add any dependency paths necessary to process matrix
		 */
		addDependencyPaths: function(h, paths) {
			paths.push("Child:SharedSpecSections/Child:SectionItems/Child:Definition/Child:ValueAttributeDefinition");
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Add sub columns and filter nodes with VisibleInAllStylesView = true
		 */
		onPathSpecParams: function(ctx, params, columnIndex) {
			const section = ctx.getNode();

			if (!section) {
				return false;
			}

			const {cache, view} = ctx;
			const {relRoot} = view;
			const targetType = relRoot.getTargetType();
			const sectionItems = cache.getNodes(section.SectionItems);
			const visibleSectionItems = sectionItems.filter(
				(item) => item && item.VisibleInAllStylesView
			);
			const n = visibleSectionItems.length;

			if (!n) {
				return false;
			}

			// create specs for each column node
			const {m_path, m_id} = params.heading;
			const specs = [];

			ctx.forEach(visibleSectionItems, (ctx, i) => {
				const sectionItem = ctx.getNode();
				const columnUrl = sectionItem.$URL;
				const defn = cache.get(sectionItem.Definition);
				const vad = cache.get(defn.ValueAttributeDefinition);
				const format = vad.Format;
				const type = vad.ValueType;
				const id = specValueIdMap[type];

				// Create Spec
				const spec = this.createSpec(ctx, targetType, m_path, m_id, sectionItem.SysID, id, format, columnUrl, defn.$Name, "");

				specs.push(spec);
			});

			params.subs = specs;
			params.headerParams.colSpan = specs.length;

			return true;
		},

		/**
		 * @override
		 * Get datasheet item node for the section item
		 */
		_getRowNodes: function(ctx, qr, c, node) {
			return [node];
		},

		/**
		 * @override
		 * The incoming nodes will be the product for the row, but here want to validate that an item exists
		 * for this spec. If not, we won't get the N/A background applied
		 */
		_getSpecNodes: function(ctx, spec, nodes) {
			const product = nodes[0];
			const item = ctx.cache.get(spec.columnUrl);
			const dataSheetItemUrl =
				product && product.SharedSectionItemMap[item.SysID];
			return xml.isValidURL(dataSheetItemUrl) ? nodes : [];
		}
	});
});
